import {Integer} from 'platform/foundation';

export const DASHBOARD_TILE_ROW_SPACING: Integer = 4;
